import { createDynamicSlice } from ".";
import { getExpenseCodeListThunk } from "../thunks/expenseCodesThunk";

export const expenseCodesSlice = createDynamicSlice({
  name: "expenseCodes",
  thunk: getExpenseCodeListThunk,
  listMode: true,
  resetActionName: "resetExpenseCodes",
});

export const expenseCodesReducer = expenseCodesSlice.reducer;
export const { resetExpenseCodes } = expenseCodesSlice.actions;
